import { render, staticRenderFns } from "./DonationThank.vue?vue&type=template&id=527bbb3e&scoped=true&"
import script from "./DonationThank.vue?vue&type=script&lang=js&"
export * from "./DonationThank.vue?vue&type=script&lang=js&"
import style0 from "./DonationThank.vue?vue&type=style&index=0&id=527bbb3e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "527bbb3e",
  null
  
)

export default component.exports